import { render, staticRenderFns } from "./RequestStudentAdmissionMessage.vue?vue&type=template&id=4ee5dc9a"
import script from "./RequestStudentAdmissionMessage.vue?vue&type=script&lang=js"
export * from "./RequestStudentAdmissionMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports